import { render, staticRenderFns } from "./declarationDialog.vue?vue&type=template&id=5691615d"
import script from "./declarationDialog.vue?vue&type=script&lang=js"
export * from "./declarationDialog.vue?vue&type=script&lang=js"
import style0 from "./declarationDialog.vue?vue&type=style&index=0&id=5691615d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports